export const InspectionFiltersOptions = Object.freeze({
    RemainingThickness: 1,
    RemainingLife: 2,
    CorrosionRate: 3,
    LastInspection_Thickness: 4,
    LastInspection_Visual: 5,
    LastInspection_Both: 6,
    NextInspection_Thickness: 7,
    NextInspection_Visual: 8,
    NextInspection_Both: 9,
    AI_Inspection: 10,
    Inspection_Tag: 11
});


export const coatingBreakdown=[
    {id: 'ri0', name: 'Ri0', tooltip: '0% rusted'},
    {id: 'ri1', name: 'Ri1', tooltip: '0.05% rusted'},
    {id: 'ri2', name: 'Ri2', tooltip: '0.5% rusted'},
    {id: 'ri3', name: 'Ri3', tooltip: '1% rusted'},
    {id: 'ri4', name: 'Ri4', tooltip: '8–39% rusted'},
    {id: 'ri5', name: 'Ri5', tooltip: '40–50% rusted'}
]

// Corrosion Analysis Constants
// Calculation Formula: 2:1 Ratio (2mm Max Distance = 1mm WT Loss)
// Note: WT Loss is always rounded UP to the nearest integer (conservative approach)
export const CORROSION_CALCULATION = {
    ratio: 2, // 2mm distance : 1mm wall thickness loss
    calculateWTLoss: (maxDistance) => Math.ceil(maxDistance / 2), // Round UP to nearest integer
    calculateMaxDistance: (wtLoss) => wtLoss * 2
};

// Pitting/Corrosion Categories for AVA Inspect Analysis
// Note: thresholdThicknessLoss and thresholdMetalLoss are MINIMUM values for category determination
// Actual WT loss should always be calculated using the 2:1 ratio formula
//
// OVERRIDE SYSTEM:
// These are the DEFAULT categories used throughout the application.
// Components support overriding these values via:
//   1. customCategories prop - Admin can provide custom category definitions
//   2. analysisData.categories - Saved analysis can include custom categories used at the time
//   3. Default fallback - If no overrides exist, these defaults are used
//
// When saving analysis results, include the categories array if custom thresholds/labels were used.
// This ensures historical data displays with the correct categories it was analyzed with.
export const pittingCategory = [
    {
        id: 'catA',
        name: 'Cat A',
        description: 'Light scale',
        thresholdThicknessLoss: 0, // mm (minimum for this category - no minimum, it's the default)
        thresholdMetalLoss: 0, // mm (minimum for this category - no minimum, it's the default)
        tooltip: 'Light scale (<2mm thickness loss, <1mm metal loss)',
        color: '#00ff00', // Green
        severityLevel: 'low'
    },
    {
        id: 'catB',
        name: 'Cat B',
        description: 'Moderate scale',
        thresholdThicknessLoss: 2, // mm (minimum for this category)
        thresholdMetalLoss: 1, // mm (minimum for this category)
        tooltip: 'Moderate scale (2-4mm thickness loss, 1-2mm metal loss)',
        color: '#ffff00', // Yellow
        severityLevel: 'moderate'
    },
    {
        id: 'catC',
        name: 'Cat C',
        description: 'Heavy scale / Flaking visible',
        thresholdThicknessLoss: 4, // mm (minimum for this category)
        thresholdMetalLoss: 2, // mm (minimum for this category)
        tooltip: 'Heavy scale / Flaking visible (4-6mm thickness loss, 2-3mm metal loss)',
        color: '#ffa500', // Orange
        severityLevel: 'high'
    },
    {
        id: 'catD',
        name: 'Cat D',
        description: 'Severe scale / Pitting or under scale holes',
        thresholdThicknessLoss: 6, // mm (minimum for this category)
        thresholdMetalLoss: 3, // mm (minimum for this category)
        tooltip: 'Severe scale / Pitting or under scale holes (6mm+ thickness loss, 3mm+ metal loss)',
        color: '#ff0000', // Red
        severityLevel: 'critical'
    }
];

// Helper functions for corrosion category determination
// Helper function to determine category based on max distance (in mm)
export function getCategoryByMaxDistance(maxDistance) {
    if (maxDistance >= 6) return pittingCategory[3]; // Cat D (Critical: ≥6mm)
    if (maxDistance >= 4) return pittingCategory[2]; // Cat C (Moderate: 4-6mm)
    if (maxDistance >= 2) return pittingCategory[1]; // Cat B (Minor: 2-4mm)
    return pittingCategory[0]; // Cat A (Normal: <2mm)
}

// Helper function to determine category based on WT loss (in mm)
export function getCategoryByWTLoss(wtLoss) {
    if (wtLoss >= 3) return pittingCategory[3]; // Cat D (Critical: ≥3mm)
    if (wtLoss >= 2) return pittingCategory[2]; // Cat C (Moderate: 2-3mm)
    if (wtLoss >= 1) return pittingCategory[1]; // Cat B (Minor: 1-2mm)
    return pittingCategory[0]; // Cat A (Normal: <1mm)
}

// Helper function to get category by ID
export function getCategoryById(categoryId) {
    return pittingCategory.find(cat => cat.id === categoryId) || null;
}

export const defectCategorization=[
    {id: 'criticalDefect', name: 'Critical Defect', tooltip: 'Critical Defect', color: '#A80000'},
    {id: 'priorityDefect', name: 'Priority Defect', tooltip: 'Priority Defect', color: '#e27640ff'},
    {id: 'defect', name: 'Defect', tooltip: 'Defect', color: '#ffbc03ff'},
    {id: 'minorImpairment', name: 'Minor Impairment', tooltip: 'Minor Impairment', color: '#3ff0afff'},
    {id: 'goodCondition', name: 'Good Condition', tooltip: 'Good Condition', color: '#036b44ff'}
]

export const component=[
    {id: 'pressureSystemPipelineDefect', name: 'Pressure System / Pipeline Defect', tooltip: 'Pressure System / Pipeline Defect'},
    {id: 'structureDefect', name: 'Structure Defect', tooltip: 'Structure Defect'}
]

// New: Filter sources enumeration for payload
export const FilterSource = Object.freeze({
    Inspections: 1,
    AvaInspections: 2,
});

export const FilterSourceList = [
    { id: FilterSource.Inspections, name: 'Inspections' },
    { id: FilterSource.AvaInspections, name: 'AVA Inspections' },
];